import { useState } from 'react'

export default function ChatInput({ onSend, loading }) {
    const [value, setValue] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!value.trim() || loading) return
        onSend(value.trim())
        setValue('')
    }

    const handleKey = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            handleSubmit(e)
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="input-wrap">
                <textarea
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    onKeyDown={handleKey}
                    placeholder="Ask anything about your data..."
                    rows={3}
                    disabled={loading}
                />
                <button type="submit" className="send-btn" disabled={loading || !value.trim()}>
                    ↑
                </button>
            </div>
        </form>
    )
}